import { render, staticRenderFns } from "./CoozzyAngleDoubleUpIcon.vue?vue&type=template&id=0b954ca8&scoped=true"
import script from "./CoozzyAngleDoubleUpIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyAngleDoubleUpIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzyAngleDoubleUpIcon.vue?vue&type=style&index=0&id=0b954ca8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b954ca8",
  null
  
)

export default component.exports